import React from 'react';
import ProgressBar from 'ps-react/ProgressBar';

/** 10% progress */
export default function Example10Percent() {
  return <ProgressBar percent={10} width={150} />
}
